import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { formatTimeline } from "../../../utils/formatTime/formatTime";
import styles from "../VideoPlayer.module.scss";
export const VideoPlayerInfo = ({ description, showDuration, duration }) => {
    const renderDescription = () => {
        if (!description) {
            return null;
        }
        return (_jsx("span", { "data-testid": "videoDescriptionBlock", className: styles.videoPlayerDescription, children: description }));
    };
    const renderDuration = () => {
        if (!showDuration) {
            return null;
        }
        return (_jsx("span", { "data-testid": "videoDurationblock", className: styles.VideoPlayerDuration, children: formatTimeline(duration) }));
    };
    return (_jsx(_Fragment, { children: (description?.length || showDuration) && (_jsxs("div", { className: classNames(styles.videoPlayerInfo), children: [renderDescription(), renderDuration()] })) }));
};
//# sourceMappingURL=VideoPlayerInfo.js.map